/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Overview_TitleInputs */

const en_case_detail_overview_title = /** @type {(inputs: Case_Detail_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case overview`)
};

const pt_br2_case_detail_overview_title = /** @type {(inputs: Case_Detail_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral do caso`)
};

/**
* | output |
* | --- |
* | "Case overview" |
*
* @param {Case_Detail_Overview_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_overview_title = /** @type {((inputs?: Case_Detail_Overview_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Overview_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_overview_title(inputs)
	return pt_br2_case_detail_overview_title(inputs)
});